import { render, staticRenderFns } from "./order-popup.vue?vue&type=template&id=4c33e99c&"
import script from "./order-popup.vue?vue&type=script&lang=js&"
export * from "./order-popup.vue?vue&type=script&lang=js&"
import style0 from "./order-popup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c33e99c')) {
      api.createRecord('4c33e99c', component.options)
    } else {
      api.reload('4c33e99c', component.options)
    }
    module.hot.accept("./order-popup.vue?vue&type=template&id=4c33e99c&", function () {
      api.rerender('4c33e99c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/account/order-popup.vue"
export default component.exports